import { View } from "binder"
import { FormBuilderElement } from "../../element";
import { ErroredElementViewModel } from "./erroredElement-viewModel"

export class ErroredElementView extends View<ErroredElementViewModel>{
    GetViewUniqueId(): string {
        return "V-96761DB5-B681-491D-88DE-639DEE717563"
    }
    loadHtml(): string {
        let element = require('./erroredElement.html').default;
        let style = require('./erroredElement.less');
        return element;
    }
    constructor() {
       super();
    }
    public set decoratorComponent(v: FormBuilderElement) { this._decoratorComponent = v; } public get decoratorComponent(): FormBuilderElement { return this._decoratorComponent;} private _decoratorComponent: FormBuilderElement;
    public set IsElementHasError(v: boolean) { this._IsElementHasError = v; } public get IsElementHasError(): boolean { return this._IsElementHasError;} private _IsElementHasError: boolean;

}
